export default __webpack_public_path__ + "static/media/lobbey5.c13b2838.jpg";